// duplicate of libs/shared/util-rxjs/src/lib/array-query.ts,
// since unfortunately one uses rxfire and the other angularfire
// TODO: unify firebase 9.x usage across Angular and React
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { query, Query, where } from 'firebase/firestore'
import { collectionData } from '@angular/fire/firestore'

import { WithId } from '@innersight-os/shared/firestore-interfaces'
import { combineLatestOrEmptyArray } from '@innersight-os/shared/util-rxjs'

// split an array up into chunks length n
function chunk<T>(values: T[], n: number): T[][] {
  const chunks: T[][] = []

  for(let i = 0; i < values.length; i += n) {
    chunks.push(values.slice(i, i+n))
  }

  return chunks
}

// This Observable circumvents Firestore's hard limit that array queries must use <=10 elements.
// Arrays longer than 10 elements are chunked into batches and a query for each one is run.
// Results are then combined and flattened every time one of the queries releases a new result.

// Firestore doesn't let you query with a list containing more than 10 elements, so we need to chunk
// the array into subarrays of <=10 and combine the queries together on the client.
export const arrayQuery = <T extends WithId>(
  ref: Query<T>,
  key: string,
  comparator: 'in' |  'not-in' | 'array-contains-any',
  values: string[],
): Observable<T[]> => {
  const chunksOfTen = chunk(values, 10)

  return combineLatestOrEmptyArray(
    chunksOfTen.map(vals =>
      collectionData<T>(
        query(
          ref,
          where(key, comparator, vals)
        ),
        {idField: 'id'},
      ) as Observable<T[]>
    )
  ).pipe(
    map(results => results.flat())
  )
}
